import { useWaitlistModal } from "../../context/waitlist-modal-context";
import { useForm } from "../../context/waitlist-context";
import { FinancialProfile } from "./financial-profile";
import { PersonalDetails } from "./personal-details";
import SuccessScreen from "./success-screen";

export default function LoanModal() {
  const { isWaitlistModalOpen, closeWaitlistModal } = useWaitlistModal();

  if (!isWaitlistModalOpen) {
    return null;
  }

  return (
    <div className="relative z-[10000]">
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-[9999] bg-black/30 backdrop-blur-xs"
        aria-hidden="true"
        onClick={closeWaitlistModal}
      />

      {/* Modal */}
      <div className="fixed z-[10000] sm:max-w-[987px] w-full h-full sm:h-fit p-0 left-0 right-0 mx-auto top-[50%] translate-y-[-50%]">
        <div className="relative sm:rounded-lg bg-white overflow-hidden w-full h-full flex flex-col">
          <>
            <Header closeWaitlistModal={closeWaitlistModal} />
            <FormContent />
          </>
        </div>
      </div>
    </div>
  );
}

const Header = ({ closeWaitlistModal }: any) => {
  const { currentStep } = useForm();
  // if (currentStep === 0) return null;
  const header = ["Personal Details", "Financial Profile", "Personal Loan"];
  return (
    <div className="flex items-center justify-between border-b p-4">
      <h2 className="text-[32px] font-semibold">{header[currentStep]}</h2>
      <button
        className="rounded-full p-2 hover:bg-gray-100"
        onClick={() => {
          closeWaitlistModal();
        }}
      >
        {/* <X className="h-5 w-5" /> */}X
      </button>
    </div>
  );
};

function FormContent() {
  const { currentStep } = useForm();

  // Render different content based on current step
  switch (currentStep) {
    case 0:
      return (
        <div className="grid sm:grid-cols-[315px,1fr] !flex-1 overflow-y-hidden">
          <div className="sm:block hidden h-full">
            <Sidebar />
          </div>
          <div className="p-6 sm:!h-[600px] !h-[calc(100svh-81px)] relative">
            <PersonalDetails />
          </div>
        </div>
      );
    case 1:
      return (
        <div className="grid sm:grid-cols-[315px,1fr] !flex-1 overflow-y-hidden">
          <div className="sm:block hidden h-full">
            <Sidebar />
          </div>
          <div className="p-6 sm:!h-[600px] !h-[calc(100svh-81px)] relative">
            <FinancialProfile />
          </div>
        </div>
      );
    case 2:
      return <SuccessScreen />;
    default:
      return null;
  }
}

function StepIndicator({
  step,
  label,
  stepTime,
  description,
}: {
  step: number;
  label: string;
  stepTime: number;
  description: string;
}) {
  const { currentStep } = useForm();
  const isActive = !(currentStep >= step - 1);
  return (
    <div className="flex items-start gap-3">
      <div
        className={`flex h-8 w-8 items-center justify-center rounded-full ${
          isActive ? "text-black" : "border border-gray-700"
        }`}
      >
        {step === 1 ? <Step1 /> : <Step2 />}
      </div>
      <div className={`${isActive && "text-[#808080]"}`}>
        <div className="text-[13px] font-[590] text-[#ecd996]">STEP {step}</div>
        <div className="font-medium text-[17px]">{label}</div>
        <div className="text-[13px]">({`${stepTime} min`})</div>
        <div className="text-[13px]">{description}</div>
      </div>
    </div>
  );
}

export const Sidebar = () => {
  return (
    <div className="bg-[#090909] p-6 text-white flex flex-col justify-between h-full">
      <div className="space-y-6">
        <StepIndicator
          step={1}
          label="Personal Details"
          stepTime={2}
          description="We use your details to verify identity and check loan eligibility."
        />
        <StepIndicator
          step={2}
          label="Financial Details"
          stepTime={2}
          description="Your financial details help us assess your loan eligibility and offer the best terms."
        />
      </div>
      {/* <div className="mt-auto pt-6">
                <div className="flex items-center gap-2 rounded-lg bg-[#262626] p-3 text-sm">
                    <img
                        src="/assets/waitlist/privacy.png"
                        alt="privacy"
                        className="p-0 w-[37px]"
                    />
                    <span className="text-[#E1E1E1] text-[13px]">
                        Your data is encrypted & 100% confidential. We will
                        never share your details.
                    </span>
                </div>
            </div> */}
    </div>
  );
};

export const Step1 = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="22" cy="22" r="21.5" stroke="#ECD996" />
      <path
        d="M28.75 20.5C28.75 20.6989 28.671 20.8897 28.5303 21.0303C28.3897 21.171 28.1989 21.25 28 21.25H24.25C24.0511 21.25 23.8603 21.171 23.7197 21.0303C23.579 20.8897 23.5 20.6989 23.5 20.5C23.5 20.3011 23.579 20.1103 23.7197 19.9697C23.8603 19.829 24.0511 19.75 24.25 19.75H28C28.1989 19.75 28.3897 19.829 28.5303 19.9697C28.671 20.1103 28.75 20.3011 28.75 20.5ZM28 22.75H24.25C24.0511 22.75 23.8603 22.829 23.7197 22.9697C23.579 23.1103 23.5 23.3011 23.5 23.5C23.5 23.6989 23.579 23.8897 23.7197 24.0303C23.8603 24.171 24.0511 24.25 24.25 24.25H28C28.1989 24.25 28.3897 24.171 28.5303 24.0303C28.671 23.8897 28.75 23.6989 28.75 23.5C28.75 23.3011 28.671 23.1103 28.5303 22.9697C28.3897 22.829 28.1989 22.75 28 22.75ZM31.75 15.25V28.75C31.75 29.1478 31.592 29.5294 31.3107 29.8107C31.0294 30.092 30.6478 30.25 30.25 30.25H13.75C13.3522 30.25 12.9706 30.092 12.6893 29.8107C12.408 29.5294 12.25 29.1478 12.25 28.75V15.25C12.25 14.8522 12.408 14.4706 12.6893 14.1893C12.9706 13.908 13.3522 13.75 13.75 13.75H30.25C30.6478 13.75 31.0294 13.908 31.3107 14.1893C31.592 14.4706 31.75 14.8522 31.75 15.25ZM30.25 28.75V15.25H13.75V28.75H30.25ZM22.7256 25.5625C22.7754 25.7552 22.7465 25.9598 22.6454 26.1312C22.5443 26.3026 22.3793 26.4268 22.1866 26.4766C21.9939 26.5263 21.7893 26.4974 21.6179 26.3963C21.4465 26.2952 21.3222 26.1302 21.2725 25.9375C21.0259 24.9756 20.0481 24.25 18.9991 24.25C17.95 24.25 16.9731 24.9756 16.7256 25.9375C16.6759 26.1302 16.5517 26.2952 16.3802 26.3963C16.2088 26.4974 16.0043 26.5263 15.8116 26.4766C15.6189 26.4268 15.4538 26.3026 15.3527 26.1312C15.2516 25.9598 15.2228 25.7552 15.2725 25.5625C15.5159 24.6566 16.0912 23.8755 16.8841 23.3744C16.4627 22.9555 16.1752 22.421 16.058 21.8386C15.9408 21.2562 15.9992 20.652 16.2257 20.1028C16.4523 19.5536 16.8368 19.084 17.3305 18.7536C17.8242 18.4232 18.405 18.2468 18.9991 18.2468C19.5932 18.2468 20.1739 18.4232 20.6676 18.7536C21.1614 19.084 21.5459 19.5536 21.7724 20.1028C21.9989 20.652 22.0573 21.2562 21.9401 21.8386C21.8229 22.421 21.5354 22.9555 21.1141 23.3744C21.9078 23.8748 22.4836 24.6562 22.7266 25.5625H22.7256ZM19 22.75C19.2967 22.75 19.5867 22.662 19.8334 22.4972C20.08 22.3324 20.2723 22.0981 20.3858 21.824C20.4994 21.5499 20.5291 21.2483 20.4712 20.9574C20.4133 20.6664 20.2704 20.3991 20.0607 20.1893C19.8509 19.9796 19.5836 19.8367 19.2926 19.7788C19.0017 19.7209 18.7001 19.7506 18.426 19.8642C18.1519 19.9777 17.9176 20.17 17.7528 20.4166C17.588 20.6633 17.5 20.9533 17.5 21.25C17.5 21.6478 17.658 22.0294 17.9393 22.3107C18.2206 22.592 18.6022 22.75 19 22.75Z"
        fill="#ECD996"
      />
    </svg>
  );
};

export const Step2 = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="22" cy="22" r="21.5" stroke="#ECD996" />
      <path
        d="M27.25 18.3972V17.875C27.25 15.5238 23.7034 13.75 19 13.75C14.2966 13.75 10.75 15.5238 10.75 17.875V21.625C10.75 23.5834 13.2109 25.1397 16.75 25.6056V26.125C16.75 28.4762 20.2966 30.25 25 30.25C29.7034 30.25 33.25 28.4762 33.25 26.125V22.375C33.25 20.4344 30.8669 18.8762 27.25 18.3972ZM31.75 22.375C31.75 23.6144 28.8634 25 25 25C24.6503 25 24.3034 24.9878 23.9613 24.9653C25.9834 24.2284 27.25 23.0312 27.25 21.625V19.9131C30.0503 20.3303 31.75 21.4628 31.75 22.375ZM16.75 24.0859V21.8556C17.496 21.9528 18.2477 22.0011 19 22C19.7523 22.0011 20.504 21.9528 21.25 21.8556V24.0859C20.5051 24.196 19.753 24.2508 19 24.25C18.247 24.2508 17.4949 24.196 16.75 24.0859ZM25.75 20.3059V21.625C25.75 22.4116 24.5866 23.2562 22.75 23.7691V21.5781C23.9603 21.2847 24.985 20.8478 25.75 20.3059ZM19 15.25C22.8634 15.25 25.75 16.6356 25.75 17.875C25.75 19.1144 22.8634 20.5 19 20.5C15.1366 20.5 12.25 19.1144 12.25 17.875C12.25 16.6356 15.1366 15.25 19 15.25ZM12.25 21.625V20.3059C13.015 20.8478 14.0397 21.2847 15.25 21.5781V23.7691C13.4134 23.2562 12.25 22.4116 12.25 21.625ZM18.25 26.125V25.7341C18.4966 25.7434 18.7459 25.75 19 25.75C19.3638 25.75 19.7191 25.7378 20.0678 25.7172C20.4552 25.8559 20.8499 25.9736 21.25 26.0697V28.2691C19.4134 27.7562 18.25 26.9116 18.25 26.125ZM22.75 28.5859V26.35C23.4958 26.4503 24.2475 26.5004 25 26.5C25.7523 26.5011 26.504 26.4528 27.25 26.3556V28.5859C25.758 28.8047 24.242 28.8047 22.75 28.5859ZM28.75 28.2691V26.0781C29.9603 25.7847 30.985 25.3478 31.75 24.8059V26.125C31.75 26.9116 30.5866 27.7562 28.75 28.2691Z"
        fill="#ECD996"
      />
    </svg>
  );
};
